export enum ScheduleStatus {
  UNDEFINED = "Undefined",
  OPEN = "Open",
  PENDING = "Pending",
  ACCEPTED = "Accepted",
  WITHDRAWN = "Withdrawn",
  DECLINED = "Declined",
  PLANNED_ABSENCE = "PlannedAbsence",
  UNPLANNED_ABSENCE = "UnplannedAbsence",
  REPORTED = "Reported",
  SUBMITTED = "Submitted",
}

export enum GigType {
  PUBLIC = "Public",
  WORKPOOL = "WorkPool",
  SOLO = "Solo",
  AUTO_GENERATED = "AutoGenerated",
}

export enum AbsenceType {
  CANCELLED_BY_EMPLOYER = "CancelledByEmployer",
  SICK_LEAVE = "SickLeave",
  SICK_LEAVE_CHILD = "SickLeaveChild",
  PARENTAL_LEAVE = "ParentalLeave",
  VACATION = "Vacation",
  OTHER = "Other",
  LEAVE_OF_ABSENCE = "LeaveOfAbsence",
}
